import fetch from '@/common/js/http';
import {SET_LOGINUSER, REMOVE_LOGINUSER} from "../mutation-types";
import {
    setToken, setUserInfo, removeToken
    , removeUserInfo, getUserInfo
} from "@/common/js/auth";

const employee = {
    namespaced: true,
    state: {
        token: '',
        employeeInfo: null,
        isLogin: false
    },
    mutations: {
        [SET_LOGINUSER](state, {token, employee}) {
            state.employeeInfo = employee
            state.isLogin = true
            state.token = token

            setToken(token)
            setUserInfo(employee)
        },
        [REMOVE_LOGINUSER](state) {
            state.employeeInfo = null
            state.isLogin = false
            state.token = ''

            removeToken()
            removeUserInfo()
        }
    },
    actions: {
        login({commit}, {loginName, password, openId}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: `ecs-user/login?username=${loginName}&password=${password}`,
                    method: 'post'
                }).then(success => {
                    resolve(success)
                    if (success && success.data) {
                        commit(SET_LOGINUSER, {token: success.data.data.token, employee: success.data.data})
                    }
                    console.log(success)
                }, error => {
                    reject(error)
                })
            })
        },
        logout({commit}) {
            commit(REMOVE_LOGINUSER)
            localStorage.clear()
        },
        changePwd({commit}, newPwd) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'changePwd',
                    method: 'post',
                    data: {password: newPwd}
                }).then(success => {
                    resolve(success)
                    console.log(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /*******************************************************************************/

        getAllUsers({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getUserWithPage({commit}, {pageSize, pageNum, nickName}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/page',
                    method: 'get',
                    params: {
                        pageSize: pageSize,
                        pageNum: pageNum,
                        nickName: nickName
                    }
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createUser({commit}, user) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user',
                    method: 'put',
                    data: user
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveUser({commit}, user) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user',
                    method: 'post',
                    data: user
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getUserProject({commit}, loadHistory) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/project',
                    method: 'get',
                    params: {"loadHistory": loadHistory}
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /*******************************************************************************/

        getUserConsumeWithPage({commit}, {pageSize, pageNum, search, projectId}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume/page',
                    method: 'get',
                    params: {
                        pageSize: pageSize,
                        pageNum: pageNum,
                        userName: search,
                        projectId: projectId
                    }
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createConsume({commit}, consume) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume',
                    method: 'put',
                    data: consume
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getConsume({commit}, {date, loadHistory}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume',
                    method: 'get',
                    params: {date: date, loadHistory: loadHistory}
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveConsume({commit}, consume) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume',
                    method: 'post',
                    data: consume
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getUserConsumeGroupList({commit}, obj) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/consume/groupList',
                    method: 'get',
                    params: obj
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },

        /*******************************************************************************/

        getAllLevelConfig({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig/all',
                    method: 'get'
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getLevelConfigWithPage({commit}, {pageSize, pageNum, keyWord}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig/page',
                    method: 'get',
                    params: {
                        pageSize: pageSize,
                        pageNum: pageNum,
                        keyWord: keyWord
                    }
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveLevelConfig({commit}, lc) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig',
                    method: 'post',
                    data: lc
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        createLevelConfig({commit}, lc) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'user/levelConfig',
                    method: 'put',
                    data: lc
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },


    }
}

export default employee



// WEBPACK FOOTER //
// ./src/vuex/modules/employee.js